import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import moment from 'moment';
import './GenAIGreenlightVersion.css'

export default function GenAIGreenlightVersion({ greenlightVersionDocID }) {
    const [isOpen, setOpenDescriptor] = useState(false);
    const [greenlights, setGreenlights] = useState([]);
    useEffect(() => {
        let docs = [];
        let greenlightVersionDocs = greenlightVersionDocID.split('$$');
        greenlightVersionDocs.forEach(x => {
            let greenlightVersion = x.split('@@');
            let _doc = { version: greenlightVersion[0], objectId: greenlightVersion[1], objectName: "", greenlightApprovedDate: "", greenlightApprovedDateStr: "", documentApprovedDate: "" }
            if (greenlightVersion.length > 2) {
                _doc.objectName = greenlightVersion[2]
            }
            if (greenlightVersion.length > 3 && greenlightVersion[3]) {

                _doc.greenlightApprovedDate = moment(greenlightVersion[3]).format("MM/DD/YYYY")
            }
            if (greenlightVersion.length > 4 && greenlightVersion[4] && greenlightVersion[4] !== "null") {

                _doc.greenlightApprovedDateStr = moment(greenlightVersion[4]).format("DD-MMM-YYYY")
            }
            if (greenlightVersion.length > 5 && greenlightVersion[5] && greenlightVersion[5] !== "null") {

                _doc.documentApprovedDate = moment(greenlightVersion[5]).format("DD-MMM-YYYY")
            }
            docs.push(_doc);
        })
        //docs = docs.sort((a, b) => parseFloat(b.version) - parseFloat(a.version));
        //docs = docs.sort((a, b) => moment(b.greenlightApprovedDate) - moment(a.greenlightApprovedDate));
        //docs = docs.sort((a, b) => moment(b.documentApprovedDate) - moment(a.documentApprovedDate));
        // if (window.location.origin === 'https://ims.jnj.com') {
        //     docs = docs.sort((a, b) => moment(b.greenlightApprovedDate) - moment(a.greenlightApprovedDate));
        // } else {
        //     docs = docs.sort((a, b) => moment(b.documentApprovedDate) - moment(a.documentApprovedDate));
        // }
        docs = docs.sort((a, b) => {
            // Primary sort: by firstName
            try {
                if (moment(b.documentApprovedDate) < moment(a.documentApprovedDate)) {
                    return -1;
                }
                if (moment(b.documentApprovedDate) > moment(a.documentApprovedDate)) {
                    return 1;
                }
                // Secondary sort: if firstNames are equal, sort by lastName
                if (moment(b.greenlightApprovedDateStr) < moment(a.greenlightApprovedDateStr)) {
                    return -1;
                }
                if (moment(b.greenlightApprovedDateStr) > moment(a.greenlightApprovedDateStr)) {
                    return 1;
                }
            } catch (error) {
                console.log("error", error)
            }
            return 0;
        });

        setGreenlights(docs);
    }, [greenlightVersionDocID])
    return (
        <div className="gen-ai-greenlight-version__root" role="region" aria-label="Greenlight Versions">
            <div className="gen-ai-greenlight-version__badge">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <title>Greenlight Version History</title>
                    <g clip-path="url(#clip0_1446_8959)">
                        <path d="M8.00016 10.6666V7.99992M8.00016 5.33325H8.00683M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1446_8959">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                <span className="gen-ai-greenlight-version__badge-label">Greenlight Versions</span>
                <svg style={isOpen ? { transform: "rotate(180deg)", cursor: "pointer" } : { cursor: "pointer" }} onClick={e => setOpenDescriptor(!isOpen)} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 6L8 10L12 6" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

            </div>
            {isOpen && <div className="gen-ai-greenlight-version__panel">
                <div className="gen-ai-greenlight-version__header">
                    <div className="gen-ai-greenlight-version__header-left">
                        <div className="gen-ai-greenlight-version__object-name">Object Name</div>
                    </div>

                    <div className="gen-ai-greenlight-version__header-right">
                        <div className="gen-ai-greenlight-version__approved-label">Greenlight Approved Date
                            <br />
                            <span className="gen-ai-greenlight-version__approved-label-subtitle">(For Safety Reporting Only)</span>
                        </div>
                    </div>
                </div>

                <div className="gen-ai-greenlight-version__list" role="list" aria-label="Version list">
                    {greenlights.map((v, idx) => (
                        <div
                            key={`${v.id}-${idx}`}
                            className="gen-ai-greenlight-version__list-item"
                            role="listitem"
                            aria-label={`Version ${v.objectId} approved ${v.greenlightApprovedDateStr}`}
                        >
                            <div className="gen-ai-greenlight-version__version-id">
                                <Link to={`/DocURL?ID=${v.objectId}&ref=Download&cs=RIMdocs&orderedBy=&orderedFor=&fileType=pdf&fileName=${v.objectName}&greenLight=true`} target="_blank">{v.objectName}
                                </Link>
                            </div>
                            <div className="gen-ai-greenlight-version__version-date">{v.greenlightApprovedDateStr}</div>
                        </div>
                    ))}
                </div>
            </div>}
        </div>
    )
}